import styled, { keyframes } from 'styled-components';
import { MIN_TABLET_BREAKPOINT, SELECTORS } from '../../../../constants/constants';

interface IProgressBarProps {
  previousHeight: number;
  newHeight: number;
}


interface IBadgeProps {
  highlightedBadge: boolean;
}

export const LoadingAnimation = ({ previousHeight, newHeight }: IProgressBarProps) => keyframes`
  from {
    height : ${previousHeight + '%'}
  }
  to {
     height : ${newHeight + '%'}
  }
`;

export const ProgressBarMobileContainer = styled.div`
    ${SELECTORS} & {
      display: none;
      margin: 0 auto;
      width: fit-content;
    }
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            display:  flex;  
            width: 80%;
        }
    } 
`;

export const BigBadgeRewardContainer = styled.div`
    display : ${({ highlightedBadge }: IBadgeProps) => highlightedBadge ? 'block' : 'none'} !important;
    ${SELECTORS} & {
        width: fit-content;
        margin: auto;
    }
    .img{
      width: auto;
      margin: auto;
    }
`;

export const MobileSideBadgesContainer = styled.div`
    ${SELECTORS} & {
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        width: 34px;
        height: 300px;
        margin: 5px 15px;
    }
`;

export const MobileSideBadgeImages = styled.div`
    opacity : ${({ highlightedBadge }: IBadgeProps) => highlightedBadge ? 1 : 0.3} !important;
    animation-name:  ${({ highlightedBadge }: IBadgeProps) => highlightedBadge ? animateBadgeIn : animateBadgeOut};
    ${SELECTORS} & {
      margin: auto;
      animation-duration: 1.5s;
    }
    
    img{
      max-width: none !important;
    }
`;

export const BadgesContainer = styled.div`
    ${SELECTORS} & {
        display: flex;
        flex-wrap: wrap;
    }
`;

//Progress bar START
export const ProgressBarContainer = styled.div`
   height: 310px;
   width: 30px;
   border-radius: 12px;
   border: 1px solid rgba(255, 255, 255, .3);  
`;

export const MobileProgressSeparator = styled.div`
    ${SELECTORS} & {
      width: 45%;
      height: 1px;
      margin: 0 auto;
      background-color: white;
    }
`;

export const ProgressBarItem = styled.div`
    border-radius: 12px;
    max-height: 300px;
    height:${({ newHeight }: IProgressBarProps) => newHeight + '%'};
    margin: 4px 4px 5px 4px;
    position: relative;
    width: 20px;
    animation:  ${({ previousHeight, newHeight }: IProgressBarProps) => LoadingAnimation({ previousHeight, newHeight })} 0.5s linear;
    background-image: linear-gradient(#47E975 3.67%, #0077EE 99.54%);;
`;
//Progress bar END


//Right badge section START
export const BadgeItemContainerMobile = styled.div`
    ${SELECTORS} & {
      margin: auto;
    }
`;

export const BadgeTopButtonMobile = styled.div`
    ${SELECTORS} & {
      text-align: center;
      background: #13A121;
      margin: 0 auto 20px auto;
      color: white;
      font-size: 14px;
      border: 1px solid #13A121;
      border-radius: 12px;
      cursor: pointer;
      width: fit-content;
      padding-left: 25px;
      padding-right: 25px;
    }
`;


export const BadgeBottomTextMobile = styled.p`
    ${SELECTORS} & {
      cursor: pointer;
      text-align: center;
      color: white;
      margin: 10px 0;
      font-size: 20px;
      font-weight: bold;
      font-family: 'Ubuntu', sans-serif;
    }
`;

export const GiftBadgeItemMobile = styled.div`
    display : ${({ highlightedBadge }: IBadgeProps) => highlightedBadge ? 'block' : 'none'} !important;
    ${SELECTORS} & {
      svg{
        height: 43px;
        width: auto;
      }
    } 
    .firstGift{
      margin-right: -6px;
    }
    .giftIcon{
       margin-right: -6px;
    }
    
    @media (max-width: 310px) {
        ${SELECTORS} & {
            svg{
                 height: 35px;
                 width: 35px;
            }
        }
        .firstGift{
          margin-right: -7px;
        }
        .giftIcon{
           margin-right: -10px;
        }
    }
`;

const animateBadgeIn = keyframes`
    0% {opacity:0.3;}
    100% {opacity:1;}
`;

const animateBadgeOut = keyframes`
    0% {opacity:1;}
    100% {opacity:0.3;}
`;


export const GiftIconMobile = styled.div`
    ${SELECTORS} & {
      width: fit-content;
       margin: auto;
    }
`;

export const GiftDescriptionMobile = styled.div`
    ${SELECTORS} & {
      color: white;
      text-align: center;
      font-size: 16px;
      font-family: 'Ubuntu', sans-serif;
    }
    b{
      color: white;
      text-align: center;
      font-family: 'Ubuntu', sans-serif;
      font-weight: bold;
      font-size:16px;
    }
`;
//Right badge section END